
import styled from "styled-components";

export const Wrapper = styled.div`
.ant-picker-input input{font-size:14px}

.products-edit-icon {
  color: #f45b68;
}

.products-edit-value {
  color: var(--app-text);
}

.products-edit-confirm {
  color: #22c55e;
}

.products-edit-cancel {
  color: #f45b68;
}

.products-cogs-link {
  color: var(--app-text);
}

.products-cogs-link--disabled {
  color: var(--app-text-muted);
  opacity: 0.6;
}

.products-search-wrap {
  background: var(--app-surface);
}

.products-search-icon {
  color: var(--app-text-muted);
}

.products-product-details-cell {
  background: var(--app-surface-alt);
}

.products-product-details-cell .fs-7 {
  color: var(--app-text-muted);
}

.products-page-table tbody td {
  color: var(--app-text);
  border-bottom-color: var(--app-border);
}

.products-page-table tbody tr:hover td {
  background: var(--app-surface-alt);
}

.products-search-input {
  color: var(--app-text) !important;
  background: var(--app-surface-alt) !important;
  border-color: var(--app-border) !important;
}

.products-search-input::placeholder {
  color: var(--app-text-muted) !important;
  opacity: 0.85;
}

[data-bs-theme="dark"] & .products-search-input {
  color: #ffffff !important;
}

[data-bs-theme="dark"] & .products-search-input::placeholder {
  color: #92929F !important;
}

.products-table-edit-input {
  color: var(--app-text) !important;
  background: var(--app-surface-alt) !important;
  border-color: var(--app-border) !important;
}

.products-mobile-card {
  background: var(--app-surface);
  border-color: var(--app-border) !important;
}

.products-mobile-card__header {
  background: var(--app-surface-alt);
}

.products-mobile-card__title {
  color: var(--app-text);
}

.products-mobile-collapse {
  background: var(--app-surface-alt);
}

.products-table-header-row {
  color: var(--app-text) !important;
}

.products-cogs-modal-title {
  color: var(--app-text);
}

.products-cogs-left-panel {
  border-right: 1px solid var(--app-border);
}

.products-cogs-section-title {
  color: var(--app-text);
}

.products-cogs-required {
  color: #f45b68;
}

.products-cogs-current-card {
  background: var(--app-surface-alt);
}

.products-cogs-current-value {
  color: #f45b68;
}

.products-cogs-date-hint {
  color: var(--app-text-muted);
}

.products-cogs-save-btn {
  color: #f45b68;
}

.products-cogs-cancel-btn {
  color: var(--app-text-muted);
}

.products-cogs-history-table-wrap {
  border: 1px solid var(--app-border);
  background: var(--app-surface);
}

.products-cogs-history-thead {
  background: var(--app-surface-alt);
  border-bottom: 2px solid var(--app-border);
}

.products-cogs-history-table {
  color: var(--app-text);
}

[data-bs-theme="dark"] & .products-cogs-cancel-btn {
  color: #a1a5b7;
}

.products-sync-btn--disabled:disabled {
  opacity: 1 !important;
  cursor: not-allowed !important;
  color: #f45b68 !important;
  background-color: rgba(244, 91, 104, 0.1) !important;
  border-color: rgba(244, 91, 104, 0.25) !important;
}

.products-sync-btn--disabled:disabled .products-sync-icon {
  color: #f45b68 !important;
  opacity: 0.55;
}

.products-sync-btn--syncing {
  opacity: 1 !important;
  pointer-events: none;
  cursor: default !important;
  color: #ffffff !important;
  background-color: #f45b68 !important;
  border-color: #f45b68 !important;
}

.products-sync-btn--syncing .products-sync-icon {
  color: #ffffff !important;
  font-size: 14px;
}

[data-bs-theme="dark"] & .products-sync-btn--disabled:disabled {
  color: #ff8a94 !important;
  background-color: rgba(244, 91, 104, 0.14) !important;
  border-color: rgba(244, 91, 104, 0.35) !important;
}

[data-bs-theme="dark"] & .products-sync-btn--disabled:disabled .products-sync-icon {
  color: #ff8a94 !important;
}

[data-bs-theme="dark"] & .products-sync-btn--syncing {
  color: #ffffff !important;
  background-color: #f45b68 !important;
  border-color: #f45b68 !important;
}

[data-bs-theme="dark"] & .products-sync-btn--syncing .products-sync-icon {
  color: #ffffff !important;
}

.smart-defaults-edit-modal .ant-modal-content,
.smart-defaults-heads-up-modal .ant-modal-content {
  background: var(--app-surface);
  border-radius: 16px;
}

.smart-defaults-edit-modal .ant-input-number,
.smart-defaults-edit-modal .ant-input-number-input {
  color: var(--app-text) !important;
  background: var(--app-surface-alt) !important;
}

.smart-defaults-edit-modal .ant-input-number-handler-wrap {
  background: var(--app-surface-alt);
  border-color: var(--app-border);
}

.smart-defaults-edit-modal .ant-form-item-label > label {
  height: auto;
}
`;
